import {
  Model,
  PagedResponse,
  PatchWithMeta,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { AnyAction } from "redux";
import { Attachment } from "../domain/Attachment";
import { PublicEnquiryModel } from "../domain/PublicEnquiry";
import { MODULE_NAME } from "../moduleName";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const LOADED_ITEMS = `${MODULE_NAME}/LOADED_ITEMS`;
export const LOADING_ITEMS = `${MODULE_NAME}/LOADING_ITEMS`;

export const LOADED_ITEM = `${MODULE_NAME}/LOADED_ITEM`;
export const LOADING_ITEM = `${MODULE_NAME}/LOADING_ITEM`;
export const SAVED_ITEM = `${MODULE_NAME}/SAVED_ITEM`;

export const UPDATING_ITEM = `${MODULE_NAME}/UPDATING_ITEM`;
export const UPDATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/UPDATING_ITEM_VALIDATION_FAIL`;

export const INPUTTING_ITEM = `${MODULE_NAME}/INPUTTING_ITEM`;
export const CREATING_ITEM = `${MODULE_NAME}/CREATING_ITEM`;
export const CREATING_ITEM_VALIDATION_FAIL = `${MODULE_NAME}/CREATING_ITEM_VALIDATION_FAIL`;
export const CREATED_ITEM = `${MODULE_NAME}/CREATED_ITEM`;

export const CLOSING_CASE = `${MODULE_NAME}/CLOSING_ITEM`;
export const REOPENING_CASE = `${MODULE_NAME}/REOPENING_ITEM`;

export const ADD_CASE_NOTE = `${MODULE_NAME}/ADD_CASE_NOTE`;
export const ADD_CASE_NOTE_ERROR = `${MODULE_NAME}/ADD_CASE_NOTE_ERROR`;
export const CLEAR_ERROR = `${MODULE_NAME}/CLEAR_ERROR`;

export const ASSIGNING_CASE = `${MODULE_NAME}/ASSIGNING_CASE`;
export const UNASSIGNING_CASE = `${MODULE_NAME}/UNASSIGNING_CASE`;

export const ADD_INTERNAL_MESSAGE = `${MODULE_NAME}/ADD_INTERNAL_MESSAGE`;
export const PUBLIC_ENQUIRIES_STORE_SEARCH = "PUBLIC_ENQUIRIES_STORE_SEARCH";

export const PUBLIC_ENQUIRY_ANALYTICS_LOADING = "PUBLIC_ENQUIRY_ANALYTICS_LOADING";
export const PUBLIC_ENQUIRY_ANALYTICS_LOADED = "PUBLIC_ENQUIRY_ANALYTICS_LOADED";

export const PUBLIC_ENQUIRY_TEAM_ANALYTICS_LOADING = "PUBLIC_ENQUIRY_TEAM_ANALYTICS_LOADING";
export const PUBLIC_ENQUIRY_TEAM_ANALYTICS_LOADED = "PUBLIC_ENQUIRY_TEAM_ANALYTICS_LOADED";

export const PENDING_LINES = `${MODULE_NAME}/PENDING_LINES`;

export const DELETE_ATTACHMENT = `${MODULE_NAME}/DELETE_ATTACHMENT`;


export const loadedItems = (payload: PagedResponse<PublicEnquiryModel>) => ({
  type: LOADED_ITEMS,
  payload,
});
export const loadingItems = (payload: QueryParams) => ({
  type: LOADING_ITEMS,
  payload,
});

export const loadedItem = (item: PublicEnquiryModel) => ({
  type: LOADED_ITEM,
  payload: item,
});

export const savedItem = (item: PublicEnquiryModel) => ({
  type: SAVED_ITEM,
  payload: item,
});

export const loadingItem = (id: string) => ({
  type: LOADING_ITEM,
  payload: id,
});

export const updatingItem = (
  id: string,
  patchWithMeta: PatchWithMeta<PublicEnquiryModel>,
  documentsToDelete: Attachment[],
  newFiles: File[]
) => ({
  type: UPDATING_ITEM,
  payload: { id, patchWithMeta, documentsToDelete, newFiles },
});

export const createItem = (item: PublicEnquiryModel) => ({
  type: CREATING_ITEM,
  payload: item,
});

export const inputtingItem = () => ({
  type: INPUTTING_ITEM,
});

export const addCaseNote = (
  id: string,
  caseFiles: File[],
  caseNote: string,
  sla_ResponseType: number,
  subject: string
) => ({
  type: ADD_CASE_NOTE,
  payload: { id, caseFiles, caseNote, sla_ResponseType, subject },
});

export const addInternalMessage = (
  id: string,
  files: File[],
  subject: string,
  message: string,
  recipients: string[]
) => ({
  type: ADD_INTERNAL_MESSAGE,
  payload: { id, files, subject, message, recipients },
});

export const addCaseNoteError = (message: string) => ({
  type: ADD_CASE_NOTE_ERROR,
  payload: { message },
});

export const clearError = () => ({ type: CLEAR_ERROR });

export const assignCase = (
  id: string,
  assignedToUpn: string,
  assignedToDisplayName: string
) => ({
  type: ASSIGNING_CASE,
  payload: { id, assignedToUpn, assignedToDisplayName },
});

export const unassignCase = (id: string) => ({
  type: UNASSIGNING_CASE,
  payload: { id },
});

export const closePublicEnquiry = (id: string) => ({
  type: CLOSING_CASE,
  payload: { id },
});
export const reopenPublicEnquiry = (id: string) => ({
  type: REOPENING_CASE,
  payload: { id },
});

export const loadAnalytics = (params: QueryParams) => ({
  type: PUBLIC_ENQUIRY_ANALYTICS_LOADING,
  payload: { params },
});

export const loadTeamAnalytics = () => ({
  type: PUBLIC_ENQUIRY_TEAM_ANALYTICS_LOADING,
});
export const loadedTeamAnalytics = (payload: Model[]) => ({
  type: PUBLIC_ENQUIRY_TEAM_ANALYTICS_LOADED,
  payload,
});

export const setPendingLines = (id: string, pendingLines : boolean) => ({
  type: PENDING_LINES,
  payload: { id, pendingLines },
});

export const deleteSelectedAttachment = (attachment: Attachment) => ({
  type: DELETE_ATTACHMENT,
  payload: {
    attachment,
  },
});
